import { fetchData } from "../../Helpers";
export const FAQ_STALE_TIME = 1000 * 60 * 5.5;
export const FAQ_CACHE_TIME = Infinity;

export function getFaqList(
  payload = {
    limit: 100,
    offset: 0,
  }
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/faq/list",
    successCallback: resObj => {
      dataLayer.push({
        "event": "view_faq_list",
        ...resObj.data
      })
    },
    payload,
    controller: controller,
  });
}
